exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-modal[data-v-08388706]{background-color:#242428;font-size:16px;color:#fff;padding:16px 24px}.content-modal[data-v-08388706]{background-color:#fff}iframe[data-v-08388706]{width:100%;border:0;height:calc(90vh - 62px)}", ""]);

// exports
